import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    GET_LEAD_BY_ID,
    SAVE_LEAD,
    GET_LEAD,
    GET_LEAD_FILTER,
    GET_LEAD_ACTIVITY,
    GET_LEAD_ACTIVITY_BY_ID,
    SAVE_ACTIVITY,
    GET_LEAD_ACTIVITY_LIST,
    INSPECTION_CREATED,
    GET_CITY,
    INSPECTION_FORM,
    SEARCH_DEALER_MASTER,
    PENDING_LIST,
    LEAD_APPROVAL_ACTION,
    ADDRESS_APPROVAL_PENDING_LIST,
    ADDRESS_APPROVAL_PENDING_BY_ID, ADDRESS_APPROVAL, ADDRESS_UPDATE_LOGS
} from "./type";
import {GET_ACCOUNT_ACTIVITY} from "../Account/type";
import {fireEvent} from "../../component/MoEngage";


export const saveLead = (params) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        params,
        `${Config.saveLead}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_LEAD,
            payload: data.response,
        });
        return true;
    }
};

export const getLeadById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getLeadById}?id=${id}`,

    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.getLeadById}?id=${id}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.getLeadById}?id=${id}`,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: GET_LEAD_BY_ID,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.getLeadById}?id=${id}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const getLead = (type, page = 1, searchKey = '', filterData = [{}], roleId = '') => async (dispatch) => {
    let urls = `${Config.getLead}?page=${page}&type=${type}&role_id=${roleId}`

    const search = window.localStorage.search_lead
    if(search){
        searchKey = search
    }

    if(searchKey !== ''){
        urls+= `&search_key=`+searchKey
    }

    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD,
            payload: data.response.data,
        });
        return true;
    }
};

export const getLeadFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadFilter}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const getActivity = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadActivities}?type=is_lead`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getActivityById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.activityById}?id=`+id,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_ACTIVITY_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const saveActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.saveLeadOrAccountActivitiesById}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getCreatedActivities = (id, page=1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadActivitiesById}?id=`+id+"&is_all="+true+"&page="+page,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_LEAD_ACTIVITY_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const createSiteInspectionForm = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.createSiteInspectionForm
    );
    if (res?.data?.response?.status === true) {
      return true;
    } else {
      return false;
    }
}

export const getAllCity = () => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      Config.getAllCity
    );
    if (res) {
        const { data } = res;
        dispatch({ type: GET_CITY, payload: data.response.data });
        return data.response.data;
      }
}

export const inspectionCreated = (request_id) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      Config.inspectionCreated+"?request_id="+request_id
    );
    if (res) {
      const { data } = res;
      dispatch({ type: INSPECTION_CREATED, payload: data.response.data });
      return data.response.data;
    }
  }

export const viewInspectionForm = (request_id, sales=true) => async (
    dispatch
  ) => {
    const res = await callWebService(
      callTypes.get,
      '',
      Config.getInspectionForm+"?request_id="+request_id+"&sales="+sales
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: INSPECTION_FORM,
        payload: data.response.data,
      });
      return true;
    }
};

export const searchDealerMaster = (searchKey, type=true) => async (
    dispatch
) => {
    const res = await callWebService(
        callTypes.get,
        '',
        Config.searchDealerMaster+"?search_key="+searchKey+"&type="+type
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SEARCH_DEALER_MASTER,
            payload: data.response.data,
        });
        return true;
    }
};

export const pendingListRequest = (moduleType, page = 1, search = '', status = 1) => async (
    dispatch
) => {
    const res = await callWebService(
        callTypes.get,
        '',
        Config.pendingLeads+"?module_type="+moduleType+"&page="+page+"&search="+search+"&status="+status
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const leadApprovalAction = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.leadApproval}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: LEAD_APPROVAL_ACTION,
            payload: data.response?.data,
        });
        return true;
    }
};

export const addressApprovalPendingListRequest = (moduleType, page = 1, search = '', status = 1) => async (
    dispatch
) => {
    const res = await callWebService(
        callTypes.get,
        '',
        Config.leadAddressApprovalList+"?module_type="+moduleType+"&page="+page+"&search="+search+"&status="+status
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ADDRESS_APPROVAL_PENDING_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const getLeadAddressPendingByIdRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.leadAddressPendingById}?id=${id}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ADDRESS_APPROVAL_PENDING_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const leadAddressApprovalActionRequest = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.leadAddressApprovalAction}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ADDRESS_APPROVAL,
            payload: data.response?.data,
        });
        return true;
    }
};

export const getAddressUpdateLogsRequest = (leadId, page = 1, filterData=[{}]) => async (dispatch) => {
    let urls = `${Config.addressUpdateLogs}?page=${page}&lead_id=${leadId}`


    Object.keys(filterData[0]).map((val, i)=>{
        urls+="&"+val+"="+filterData[0][val]
    })

    const res = await callWebService(
        callTypes.get,
        '',
        urls,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ADDRESS_UPDATE_LOGS,
            payload: data.response?.data,
        });
        return true;
    }
};